import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import CourierExpressDeliveryData from '@/store/entities/courier-express-delivery'

interface CourierExpressDeliveryState extends ListState<any> {
    orderInfo: CourierExpressDeliveryData,
}

class CourierExpressDeliveryMutations extends ListMutations<any>{

}
class CourierExpressDelivery extends ListModule<CourierExpressDeliveryState, any, any>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<any>(),
        loading: false,
    }
    actions = {
        async getAll(context: ActionContext<CourierExpressDeliveryState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/CourierExpressDelivery/GetList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<any>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async update(context: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/CourierExpressDelivery/MarkNotEnable?id=' + payload.data.id);
        },
        async add(context: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/CourierExpressDelivery/Add', payload.data);
            return rep.data.result;
        },
        async exportExcel(state: any, payload: any) {
            Ajax.get('/api/File/GetCourierExpressDeliveryExport', { params: payload.data, responseType: "blob" }).then(res => {
                const content = res.data;
                const blob = new Blob([content]);
                const fileName = '快递入库记录.xlsx'

                if ('download' in document.createElement('a')) { // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = fileName

                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)
                }
            });
        }

    };
    mutations = {
        setCurrentPage(state: CourierExpressDeliveryState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: CourierExpressDeliveryState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}

const CourierExpressDeliveryModel = new CourierExpressDelivery();
export default CourierExpressDeliveryModel;